<template>
  <div>
    <table class="table table-responsive">
      <tbody>
        <tr v-if="status">
          <th style="border-top: none">Status</th>
          <td style="border-top: none">
            <EpcStatus :status="status" />
          </td>
        </tr>
        <tr>
          <th>{{ $t('name') }}</th>
          <td>
            {{
              saveGet(
                fixedPhysicalLocation,
                '-',
                'physicalLocationName',
                0,
                'value'
              )
            }}
          </td>
        </tr>
        <tr>
          <th>{{ $t('role') }}</th>
          <td>
            <ul style="padding-left: 0" id="v-roles-list">
              <p
                v-if="roles.length > 0"
                v-for="role in roles"
                :key="role.toString() + Math.random() + Math.random()"
              >
                {{ $t(`locationType.${role}_title`) }}
              </p>
              <p v-else>-</p>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{ $t('more_locations') }}</th>
          <td>
            <template
              v-if="additionalIDs instanceof Array && additionalIDs.length > 0"
            >
              <p
                v-for="additionalID in additionalIDs"
                :key="additionalID.toString() + Math.random()"
              >
                {{
                  $t(`locationIdType.${additionalID.locationID_Type}_title`)
                }}:
                {{ additionalID.locationID }}
              </p>
            </template>
            <template v-else> - </template>
          </td>
        </tr>
        <tr>
          <th>{{ $t('adress') }}</th>
          <td style="border-bottom: 0">
            <Address
              :show-map="showMap"
              :address="saveGet(fixedPhysicalLocation, null, 'address', 0)"
            />
          </td>
        </tr>
        <tr>
          <th>{{ $t('geo') }}</th>
          <td>
            {{
              saveGet(fixedPhysicalLocation, '-', 'geoCoordinates', 'latitude')
            }}
            ,
            {{
              saveGet(fixedPhysicalLocation, '-', 'geoCoordinates', 'longitude')
            }}
          </td>
        </tr>
        <tr>
          <th>{{ $t('contact') }}</th>
          <td style="border-bottom: 0">
            <Contact
              :contact="saveGet(fixedPhysicalLocation, null, 'contactPoint', 0)"
            />
          </td>
        </tr>
        <links-tr :linkSet="linkSet">{{ $t('targets') }}</links-tr>
        <tr>
          <th>{{ $t('last_update') }}</th>
          <td style="border-bottom: none">{{ dateUpdated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { saveGet } from '../mixins/saveGet'
import Address from './Address'
import Contact from './Contact'
import moment from 'moment/moment'
import EpcStatus from './EpcStatus.vue'
import LinksTr from '@/components/LinksTr.vue'

export default {
  name: 'FixedPhysicalLocation',
  props: ['fixedPhysicalLocation', 'showMap', 'status', 'linkSet'],
  components: {
    EpcStatus,
    Contact,
    Address,
    LinksTr
  },
  mixins: [saveGet],
  computed: {
    roles() {
      return this.saveGetAndMap(
        this.fixedPhysicalLocation,
        [],
        arr => arr.filter(x => x),
        'locationRole'
      )
    },
    additionalIDs() {
      return this.saveGet(
        this.fixedPhysicalLocation,
        null,
        'additionalLocationID'
      )
    },
    dateUpdated() {
      let updated = this.saveGet(this.fixedPhysicalLocation, '', 'dateUpdated')
      if (!updated) {
        return '-'
      }
      return moment(updated).format('DD. MMM YYYY')
    }
  },
  i18n: {
    messages: {
      de: {
        name: 'Name',
        role: 'Lokationsrolle',
        contact: 'Kontakt',
        last_update: 'Zuletzt geändert',
        adress: 'Adresse',
        geo: 'Geokoordinaten',
        more_locations: 'Weitere Lokation-IDs',
        targets: 'Lokationsbezogene Verlinkungen'
      },
      en: {
        name: 'Name',
        role: 'Location role',
        contact: 'Contact',
        last_update: 'Last update',
        adress: 'Address',
        geo: 'Geocoordinates',
        more_locations: 'Additional location-IDs',
        targets: 'Location related links'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FixedPhysicalLocation.vue